import React from "react";
import { fieldErrorId } from "./checkerValidation";

/**
 * Inline validation message rendered under a field. The control that fails
 * validation references this element through `aria-describedby`
 * (see `invalidInputProps`), so it is announced next to the visible label.
 */
export default function FieldError({ name, message, className = "" }) {
  if (!message) return null;
  return (
    <p
      id={fieldErrorId(name)}
      data-field-error={name}
      className={`text-sm leading-snug mt-1.5 ${className}`}
      style={{ color: "#B91C1C" }}
    >
      {message}
    </p>
  );
}
